import { memo, useEffect } from 'react';
import classes from './agreement.module.scss';

type Props = {};

export const AgreementPage = memo((_props: Props) => {
	useEffect(() => {
		document.title = 'GakkenID｜規約';
	}, []);

	return (
		<>
			<section className={`section ${classes.section_overrie}`}>
				<div className={`section-in ${classes.body_css}`}>
					<div className={classes.top_title}>
						<h1 className={classes.agreement_title}>GakkenID 規約</h1>
						<a className={classes.english} href="/agreement-en">
							English
						</a>
					</div>

					<div className={classes.block01}>
						<h3>{`第1条${'　'}定義`}</h3>
						<div className={classes.reg0}>
							Gakken ID規約（以下「本規約」といいます）における用語の定義は以下のとおりとします。
						</div>

						<div className={classes.reg1}>
							<ol>
								<li>
									「学研」とは、株式会社学研プロダクツサポート（以下「当社」といいます）を含む学研グループを構成する各会社をいいます。
								</li>
								<li>
									「Gakken
									ID」とは、「学研」が提供する本サービスおよび対象サービスを利用するために必要となるアカウントIDをいいます。ID保有者は、Gakken
									IDを利用することで、対象サービスに係るウェブサイトにログインすることができます。
								</li>
								<li>
									「ID保有者」とは、本サービスに係るウェブページ上で当社の定める必要な情報を入力するID登録申込をし、当社によりGakken
									IDの利用につき承認を受けた者をいいます
								</li>
								<li>「ID登録申込」とは、Gakken IDの利用のための登録申込手続をいいます。</li>
								<li>「本サービス」とは、「Gakken ID」を発行・管理するサービスをいいます。</li>
								<li>
									「対象サービス」とは、「Gakken
									ID」を利用して受けられるインターネットを利用した情報提供、ショッピング、課金・決済サービスなどの学研が行う個々のサービスをいいます。対象サービスの詳細は対象サービスのページをご確認ください。
								</li>
							</ol>
						</div>
					</div>

					<div className={classes.block01}>
						<h3>第2条（規約の適用）</h3>

						<div className={classes.reg1}>
							<ol>
								<li>本規約は、 ID保有者に対して適用されます。</li>
								<li>
									本規約の内容は、ID保有者への事前の通知なしに必要に応じて変更することがありますので、本サービスおよび対象サービスをご利用の際には本サービスに係るウェブページ上に掲載されている最新の本規約をご確認下さい。
								</li>
								<li>
									当社が前項に基づき本規約の内容変更を行った後、
									ID保有者が本サービスまたは対象サービスを利用した場合、当該
									ID保有者は本規約の変更を承諾したものとみなすものとします。
								</li>
								<li>
									当社が本サービスに係るウェブページ上に掲載する諸注意等が存在する場合、当該諸注意等は本規約の一部を構成するものとします。
								</li>
							</ol>
						</div>
					</div>

					<div className={classes.block01}>
						<h3>第3条（Gakken ID保有者）</h3>

						<div className={classes.reg1}>
							<ol>
								<li>
									{' '}
									ID登録申込後、当社がGakken
									IDの利用につき承認した場合は、ID保有者として、対象サービスを利用できるものとします。
								</li>
								<li> ID保有者は、ID保有者となった時点で、本規約の内容に同意したものとみなされます。</li>
								<li> ID保有者は、ID登録申込に際して、以下の条件を了承し、遵守するものとします。</li>

								<div className={classes.reg2}>
									<p>
										（1）本サービスに係るID保有者登録専用ページの入力欄に、ID保有者自身のID登録に必要なデータを真実かつ正確に入力すること。代理による入力・ID登録申込は一切認められません。
									</p>
									<p>
										（2）ID登録申込時にメールアドレスを登録する際は、ID保有者自身の保有するメールアドレスを登録すること。他人のメールアドレスでの登録は認められません。
									</p>
									<p>（3）(1)の登録事項に変更があった場合、ID保有者は速やかに登録内容の変更を行うこと。</p>
									<p>（4）1人のID保有者による複数のIDの登録および保有は認められません。</p>
									<p>（5）18歳未満のID保有者は、保護者の同意を得てID登録申込みを行うこと。</p>
								</div>
								<div className={classes.reg1}>
									<li>
										ID保有者は対象サービスを利用するにあたり、Gakken
										IDおよびID登録申込時に登録したパスワードを入力するものとし、学研は、Gakken
										IDおよびパスワードを利用して行われた行為を、ID保有者による利用とみなすものとします。万一Gakken
										IDまたはパスワードを盗用されて使用された場合や不正使用された場合であっても、当該行為による責任は学研に故意または重大な過失がない限り、ID保有者が負うものとします。
									</li>
									<li>
										学研は、ID保有者が下記のいずれかに該当した場合、当該ID保有者への事前通知を行うことなく当該ID保有者への本サービスおよび対象サービスの全部または一部の利用停止・終了、Gakken
										IDの抹消、パスワードの削除ならびにID保有者資格の剥奪、損害賠償請求等の必要な対応（法的措置を含みますが、これに限りません）を行うことがあります。なお、当該対応の結果、当該ID保有者に損害や不利益が生じた場合でも、学研は一切の責任を負わないものとします。
									</li>
								</div>
								<div className={classes.reg2}>
									<p>
										（1）ID保有者が本規約または対象サービスの利用時に提示される対象サービスごとの利用規約（以下「対象サービス利用規約」といいます）や諸注意等に違反すると学研が判断する場合またはそのおそれがあると学研が判断する場合
									</p>
									<p>（2）ID保有者が本サービスまたは対象サービスの運営上不適当と学研が判断する行為を行った場合</p>
								</div>
								<div className={classes.reg1}>
									<li>
										ID保有者は、対象サービスを利用する場合、対象サービス利用規約を確認し、同意した上で、対象サービスを利用するものとします。
									</li>
								</div>
							</ol>
						</div>

						<div className={classes.block01}>
							<h3>第4条（ID保有者の禁止事項）</h3>
							<div className={classes.reg0}>
								ID保有者は、本サービスおよび対象サービスを利用するにあたり以下の行為または以下に該当するおそれがあると学研が判断する行為を行わないものとします。
							</div>

							<div className={classes.reg2}>
								<ol>
									<p>（1）学研、他のID保有者または第三者の著作権、肖像権、その他知的所有権を侵害する行為</p>
									<p>（2）学研、他のID保有者または第三者の財産、プライバシー等を侵害する行為</p>
									<p>（3）学研、他のID保有者または第三者に対する誹謗中傷、迷惑となる行為、不快感を抱かせる行為</p>
									<p>
										（4）当社の本サービスに係るサーバー等のコンピュータに不正にアクセスし、または有害なコンピュータプログラム、有害なメール等を送信し、もしくは書き込む行為
									</p>
									<p>（5）本サービスおよび対象サービスを商用目的で利用する行為</p>
									<p>（6）犯罪的行為に結びつく行為</p>
									<p>
										（7）本サービスおよび対象サービスを通じて入手した情報を、複製、販売その他私的利用の範囲を超えて使用する行為
									</p>
									<p>
										（8）本サービスおよび対象サービスの運営を妨げ、あるいは学研または学研の提携先の信頼を毀損するような行為
									</p>
									<p>（9）営業活動、営利を目的とした情報提供活動を行う行為</p>
									<p>
										（10）本サービスおよび対象サービスを使用して、学研または学研の提携先を故意に虚偽情報の提供や脅迫によって困惑させる行為
									</p>
									<p>（11）その他、法律、法令、公序良俗または本規約に違反する行為または違反のおそれのある行為</p>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第5条（不保証）</h3>
							<div className={classes.reg0}>
								学研は、本サービスおよび対象サービスにおいて信頼できるサービスや情報をID保有者へ届けるべく努力をしていますが、次の各号について、一切保証しません。本サービスおよび対象サービスの利用に際しては、ID保有者自身が、本サービスおよび対象サービスにおいて提供される情報やサービスの有用性等を判断し、自身の責任でご利用下さい。
							</div>

							<div className={classes.reg2}>
								<ol>
									<p>
										（1）本サービスおよび対象サービス上で提供される全ての情報（対象サービスとして、および対象サービス上に表示される、第三者が管理・運営するリンクサイト内に含まれる一切の情報等を含み、以下同様とします）に関する、有用性、適合性、完全性、正確性、安全性、合法性、最新性等
									</p>
									<p>
										（2）本サービスおよび対象サービスを通じて入手できる商品、役務、情報等がID保有者の希望または期待を満たす適切なものであること
									</p>
									<p>（3）本サービスおよび対象サービスの提供に不具合、エラーまたは障害が生じないこと</p>
									<p>
										（4）本サービスおよび対象サービスに関連して送信される電子メール、ウェブコンテンツ等に、コンピュータウィルス等の有害なものが含まれていないこと
									</p>
									<p>（5）本サービスおよび対象サービスの存続または同一性が維持されること</p>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第6条（学研・ID保有者の責任）</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										学研は、ID保有者の本サービスおよび対象サービスの利用または利用不能により生じる一切の損害（以下の各号に定める損害、ID保有者もしくは第三者に生じた精神的苦痛、またはその他の金銭的損失を含む不利益を含みますが、これに限りません）に関して学研に故意・重過失がない限り一切の責任を負わないものとします。また、学研が責任を負う場合であっても、学研の責任は直接かつ通常の損害に限られるものとします。
									</li>
									<div className={classes.reg2}>
										<p>
											（1）本サービスおよび対象サービスを介して行う、第三者が提供するコンテンツのダウンロード、および、第三者が管理・運営するリンクサイトへのアクセス等の行為により、ID保有者に生じた損害
										</p>
										<p>
											（2）学研が相当の安全策を講じたにもかかわらず、本サービスおよび対象サービスの無断改変、本サービスおよび対象サービスに関するデータへの不正アクセス、コンピュータウィルスの混入等の不正行為が行われ、これに起因してID保有者に生じた損害
										</p>
										<p>
											（3）通信回線や、コンピュータ等の障害によるシステムまたはサービスの中断、遅滞、中止、データ消失、不正アクセスにより生じた損害
										</p>
									</div>
									<li>
										ID保有者の本規約または対象サービス利用規約に違反する行為によって、学研または第三者が損害を被った場合、当該ID保有者は、自己の責任と費用をもって、当該損害の一切を賠償しなければなりません。
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第7条（個人情報の取扱）</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										当社は、ID保有者のプライバシーを尊重し、ID保有者の個人情報の管理に細心の注意を払います。本サービスの管理・運営に当たって、当社がID保有者から取得した個人情報は、別途定める「個人情報取り扱いについて」（
										<a className={classes.close} href="https://gakken-ps.co.jp/privacypolicy/" target="_blank">
											https://gakken-ps.co.jp/privacypolicy/
										</a>
										）に従って取り扱うものとします。
									</li>
									<li>当社は、ID保有者の個人情報を、次の通り共同利用します。</li>
									<div className={classes.reg2}>
										<p>&#9312;共同利用する個人情報の項目</p>
									</div>
									<div className={classes.reg3}>
										<p>GakkenIDに登録する一切の個人情報（第8条に定める属性情報・行動履歴を含む）</p>
									</div>
									<div className={classes.reg2}>
										<p>&#9313;共同して利用する者の範囲</p>
									</div>
									<div className={classes.reg3}>
										<p>当社を含む学研グループを構成する各会社</p>
									</div>
									<div className={classes.reg2}>
										<p>&#9314;共同利用における利用目的</p>
									</div>
									<div className={classes.reg3}>
										<p>
											（ⅰ）ECサイト（対象サービスを含む）その他学研グループを構成する各社の事業に関連するサービスの提供、および当該サービス提供に付随する行為（マーケティング、新商品・サービスの企画開発等）
										</p>
										<p>
											（ⅱ）学研グループを構成する会社及びその提携先である第三者の商品・サービスの紹介・案内。なお、取得した第8条に定める属性情報・行動履歴等の情報を分析して、ID保有者の関心等に応じて商品・サービスの紹介・案内を行うことを含みます。
										</p>
									</div>
									<div className={classes.reg2}>
										<p>&#9315;個人情報の管理について責任を有する者の名称・所在地・代表者</p>
									</div>
									<div className={classes.reg3}>
										<p>株式会社学研プロダクツサポート</p>
										<div className={classes.reg3}>
											<p>所在地・代表者の詳細については、以下をご確認ください。</p>
											<div className={classes.reg3}>
												<p>
													<a
														className={classes.close}
														href="https://gakken-ps.co.jp/company/about.html"
														target="_blank"
													>
														https://gakken-ps.co.jp/company/about.html
													</a>
												</p>
											</div>
										</div>
									</div>
									<li>
										当社は、ID保有者が対象サービスの利用を停止しまたは対象サービス独自の会員制度から退会等（理由は問いません）したとしても、ID保有者が自ら別途当社が定める手続きに従いGakken
										IDを抹消しない限り、ID保有者の個人情報を保有し利用し続けることができるものとし、ID保有者は、これを予め同意するものとします。
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第8条（属性情報・行動履歴の取得および利用）</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										学研は、ID保有者により本サービスおよび対象サービスの利用を通じて提供された年齢や性別、職業、居住地域等の属性情報および対象サービスにおけるID保有者の行動履歴を取得し、対象サービスの提供に必要な範囲で利用すること、および当該属性情報・当該行動履歴に基づき作成された統計データについて、何らの制限なく利用することができることに、ID保有者は予め承諾します。なお、学研は、法律上の根拠に基づき要求された場合およびID保有者の同意を得た場合を除き、ID保有者個人を特定できる情報を第三者に開示しないものとします。
									</li>
									<li>
										学研は、ID保有者がGakken
										IDを用いて対象サービスにログインしこれを利用した場合、個人を特定したうえで、これまでに取得した属性情報および行動履歴を用いて、広告等の配信・表示および対象サービスの提供を行うことができるものとし、ID保有者はこれを予め承諾します。
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第9条（対象サービスの変更・中断・終了）</h3>

							<div className={classes.reg1}>
								<ol>
									<li>
										学研は、ID保有者に事前に通知することなく、本サービスおよび対象サービスの全部または一部を変更、中断、終了することができるものとします。ただし、学研が本サービスおよび対象サービスの全部を終了する場合には、ID保有者に対し、事前に学研の定める方法で通知するものとします。
									</li>
									<li>
										本サービスおよび対象サービスの全部または一部の変更・中断・終了に伴い、ID保有者に不利益や損害が発生した場合であっても、学研は一切の責任を負わないものとします。
									</li>
								</ol>
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第10条（反社会的勢力の排除）</h3>
							<div className={classes['reg0-sub']}>
								ID保有者は、反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者をいいます。）に該当しないこと、また暴力的行為、詐術・脅迫行為、業務妨害行為等違法行為を行わないことを、将来にわたっても表明するものとします。かかる表明に違反した場合には、異議なく本サービスおよび対象サービスの利用停止・終了、GakkenIDの抹消、パスワードの削除ならびにID保有者資格の剥奪、損害賠償請求等の対応（法的措置を含みますが、これに限りません）を受け入れるものとします。
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第11条（権利義務の譲渡禁止）</h3>
							<div className={classes['reg0-sub']}>
								ID保有者は、本サービスおよび対象サービスに関するID保有者としての地位および当該地位に基づく権利義務を、当社が予め承諾した場合を除き、第三者に譲渡しまたは担保に供してはならないものとします。
							</div>
						</div>

						<div className={classes.block01}>
							<h3>第12条（準拠法および管轄）</h3>
							<div className={classes['reg0-sub']}>
								本規約は日本法に基づいて解釈され、本規約に関する紛争の第一審の専属的合意管轄裁判所は、当社本店所在地を管轄する地方裁判所または簡易裁判所を第一審専属管轄裁判所とします。
							</div>
						</div>

						<div className={classes.block02}>
							<h3></h3>
							<div>
								<p>附則</p>
								<p>{`2018年1月1日${'　'}制定・施行`}</p>
								<p>{`2020年7月15日${'　'}改正`}</p>
								<p>{`2021年2月1日${'　'}改正`}</p>
								<p>{`2022年3月28日${'　'}改正`}</p>
							</div>
						</div>
					</div>

					<br />
					<div className={classes['c-bg_box_Border']}>
						<p>
							<a className={classes.close} href="#" onClick={() => window.close()}>
								閉じる
							</a>
						</p>
					</div>
				</div>
			</section>
		</>
	);
});
